export default function GettingStarted() {
  return (
    <div>
      <h1 style={s.pageTitle}>Getting Started</h1>
      <p style={s.pageSub}>Everything you need to know to get the most out of JobConfirmed.</p>

      {/* Quick start */}
      <div style={s.card}>
        <h2 style={s.cardTitle}>Quick Start — 4 Simple Steps</h2>
        <div style={s.steps}>

          <div style={s.step}>
            <div style={s.stepNum}>1</div>
            <div style={s.stepContent}>
              <div style={s.stepTitle}>Set Up Your Business</div>
              <p style={s.stepDesc}>
                Go to <strong style={{color:'#4f46e5'}}>Settings</strong> and enter your business name, 
                your mobile number (for no-show alerts), and your Google review link. 
                This takes less than 2 minutes and only needs to be done once.
              </p>
            </div>
          </div>

          <div style={s.step}>
            <div style={s.stepNum}>2</div>
            <div style={s.stepContent}>
              <div style={s.stepTitle}>Add a Job</div>
              <p style={s.stepDesc}>
                Click <strong style={{color:'#4f46e5'}}>+ Add Job</strong> and enter your customer's name, 
                phone number, appointment date and time. Optionally add a service type, technician name, 
                and internal job number. That's all you need to do — everything else is automatic.
              </p>
            </div>
          </div>

          <div style={s.step}>
            <div style={s.stepNum}>3</div>
            <div style={s.stepContent}>
              <div style={s.stepTitle}>We Text Your Customer</div>
              <p style={s.stepDesc}>
                JobConfirmed automatically sends your customer two reminders:
              </p>
              <div style={s.smsExamples}>
                <div style={s.smsCard}>
                  <div style={s.smsLabel}>24 Hours Before</div>
                  <div style={s.smsBubble}>
                    Hi John, confirming your AC Repair appointment tomorrow at 2pm with Stephen's HVAC Company. 
                    Reply C to confirm or call us to reschedule. Reply STOP to opt out.
                  </div>
                </div>
                <div style={s.smsCard}>
                  <div style={s.smsLabel}>2 Hours Before</div>
                  <div style={s.smsBubble}>
                    Hi John, your tech Mike is scheduled to arrive around 2pm today. 
                    Reply C to confirm you'll be home. Reply STOP to opt out.
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={s.step}>
            <div style={s.stepNum}>4</div>
            <div style={s.stepContent}>
              <div style={s.stepTitle}>Mark Complete & Get a Review</div>
              <p style={s.stepDesc}>
                When the job is done click <strong style={{color:'#4f46e5'}}>✓ Complete</strong> on the job card. 
                Your customer automatically receives a Google review request within the hour.
              </p>
              <div style={s.smsExamples}>
                <div style={s.smsCard}>
                  <div style={s.smsLabel}>After Job Completion</div>
                  <div style={s.smsBubble}>
                    Thanks for choosing Stephen's HVAC Company! If your tech did a great job today 
                    we'd love a quick review — it takes 30 seconds: https://maps.google.com 
                    Reply STOP to opt out.
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Job status guide */}
      <div style={s.card}>
        <h2 style={s.cardTitle}>Understanding Job Statuses</h2>
        <div style={s.statusGrid}>
          <div style={s.statusItem}>
            <span style={{...s.badge, color:'#f59e0b', background:'#2a1f0a'}}>Pending</span>
            <p style={s.statusDesc}>Reminder sent — waiting for customer to reply C.</p>
          </div>
          <div style={s.statusItem}>
            <span style={{...s.badge, color:'#22c55e', background:'#0a2a14'}}>Confirmed</span>
            <p style={s.statusDesc}>Customer replied C — they'll be home.</p>
          </div>
          <div style={s.statusItem}>
            <span style={{...s.badge, color:'#ef4444', background:'#2a1a1a'}}>No Response</span>
            <p style={s.statusDesc}>Customer hasn't confirmed — you've been alerted. Consider calling ahead.</p>
          </div>
          <div style={s.statusItem}>
            <span style={{...s.badge, color:'#6b6b80', background:'#1a1a24'}}>Complete</span>
            <p style={s.statusDesc}>Job done — review request has been sent to the customer.</p>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div style={s.card}>
        <h2 style={s.cardTitle}>Common Questions</h2>
        <div style={s.faqList}>

          <div style={s.faqItem}>
            <div style={s.faqQ}>When exactly are reminders sent?</div>
            <div style={s.faqA}>24 hours before the appointment and again 2 hours before. The system checks every 15 minutes so reminders fire within 15 minutes of the scheduled window.</div>
          </div>

          <div style={s.faqItem}>
            <div style={s.faqQ}>What if I add a job less than 24 hours before the appointment?</div>
            <div style={s.faqA}>The 24hr reminder will be skipped and only the 2hr reminder will fire. If the appointment is within 2 hours neither reminder will send.</div>
          </div>

          <div style={s.faqItem}>
            <div style={s.faqQ}>What if my customer doesn't confirm?</div>
            <div style={s.faqA}>You'll get a text alert to your mobile number 30 minutes after the 2hr reminder if the customer still hasn't replied. You can then decide whether to call ahead.</div>
          </div>

          <div style={s.faqItem}>
            <div style={s.faqQ}>Can I edit a job after adding it?</div>
            <div style={s.faqA}>Yes — click the Edit button on any job card to update the customer name, phone, date, time, service type, tech name, or job number.</div>
          </div>

          <div style={s.faqItem}>
            <div style={s.faqQ}>Do I need to enter phone numbers with +1?</div>
            <div style={s.faqA}>No — just enter the 10 digit number. JobConfirmed automatically adds the +1 country code.</div>
          </div>

          <div style={s.faqItem}>
            <div style={s.faqQ}>Can my customer opt out?</div>
            <div style={s.faqA}>Yes — every message includes opt-out instructions. If a customer replies STOP they will not receive any further messages.</div>
          </div>

          <div style={s.faqItem}>
            <div style={s.faqQ}>How do I update my Google review link?</div>
            <div style={s.faqA}>Go to Settings and update the Google Review Link field. Find your link in Google Business Profile under the Reviews section.</div>
          </div>

        </div>
      </div>

      {/* Support */}
      <div style={{...s.card, textAlign:'center'}}>
        <h2 style={s.cardTitle}>Need Help?</h2>
        <p style={{color:'#6b6b80', fontSize:14, marginBottom:16}}>
          Can't find what you're looking for? Reach out and we'll get back to you quickly.
        </p>
        <a href="mailto:stephen@jobconfirmed.com" style={s.supportBtn}>
          Contact Support
        </a>
      </div>

    </div>
  )
}

const s = {
  pageTitle: { fontSize: 28, fontWeight: 700, margin: '0 0 8px', color: '#fff', fontFamily: "'DM Sans', sans-serif" },
  pageSub: { color: '#6b6b80', fontSize: 14, margin: '0 0 32px', fontFamily: "'DM Sans', sans-serif" },
  card: {
    background: '#13131a', border: '1px solid #1e1e2e',
    borderRadius: 16, padding: '28px 32px', marginBottom: 20,
    fontFamily: "'DM Sans', sans-serif",
  },
  cardTitle: { color: '#fff', fontSize: 18, fontWeight: 700, margin: '0 0 24px' },
  steps: { display: 'flex', flexDirection: 'column', gap: 28 },
  step: { display: 'flex', gap: 20, alignItems: 'flex-start' },
  stepNum: {
    background: '#4f46e5', color: '#fff', width: 36, height: 36,
    borderRadius: '50%', display: 'flex', alignItems: 'center',
    justifyContent: 'center', fontWeight: 700, fontSize: 16, flexShrink: 0,
  },
  stepContent: { flex: 1 },
  stepTitle: { color: '#fff', fontSize: 16, fontWeight: 600, marginBottom: 8 },
  stepDesc: { color: '#a0a0b8', fontSize: 14, lineHeight: 1.6, margin: 0 },
  smsExamples: { display: 'flex', flexDirection: 'column', gap: 12, marginTop: 12 },
  smsCard: {
    background: '#0a0a0f', border: '1px solid #1e1e2e',
    borderRadius: 10, padding: '12px 16px',
  },
  smsLabel: { color: '#4f46e5', fontSize: 11, fontWeight: 700, marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.5px' },
  smsBubble: { color: '#a0a0b8', fontSize: 13, lineHeight: 1.6 },
  statusGrid: { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 },
  statusItem: { display: 'flex', flexDirection: 'column', gap: 8 },
  badge: { padding: '4px 12px', borderRadius: 6, fontSize: 13, fontWeight: 600, alignSelf: 'flex-start' },
  statusDesc: { color: '#6b6b80', fontSize: 13, margin: 0, lineHeight: 1.5 },
  faqList: { display: 'flex', flexDirection: 'column', gap: 0 },
  faqItem: {
    borderBottom: '1px solid #1e1e2e', paddingBottom: 16, marginBottom: 16,
  },
  faqQ: { color: '#fff', fontSize: 14, fontWeight: 600, marginBottom: 6 },
  faqA: { color: '#6b6b80', fontSize: 14, lineHeight: 1.6 },
  supportBtn: {
    display: 'inline-block', background: '#4f46e5', color: '#fff',
    borderRadius: 8, padding: '11px 24px', fontSize: 14,
    fontWeight: 600, textDecoration: 'none',
  },
}
